import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)

Vue.config.productionTip = false
Vue.mixin({
  data () {
    return {
      timeZone: 'America/Guayaquil',
      lang: 'es-ES',
      /**Reglas de validacion */
      reglas: {
        requeridoTxt: value => {
          return !!value || 'Campo requerido.'
        },
        requeridoCbx: value => {
          if (typeof value !== 'object') {
            return 'Campo requerido.'
          }
          return !!value || 'Campo requerido.'
        },
        formatoEmail: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-mail invalido.'
        },        
        largo(max){
          return v => (v || '').length <= max || 'EL máximo de caracteres aceptados es : ' + max;
        }
      },
      /** Data Swal */
      dswalEliminar: {
        title: 'Alerta',
        text: 'Desea eliminar este elemento?',
        icon: 'warning',
        showCancelButton: true
      }
    }
  },  
})
new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
